<template>
  <div class="event-main">
    <div class="table">
      <div class="table-header">
        <div class="table-header-event">
          イベント名
        </div>

        <div class="table-header-place">
          開催地
        </div>

        <div class="table-header-date">
          開催日
        </div>

        <div class="table-header-start">
          開始時間
        </div>

        <div class="table-header-finish">
          終了時間
        </div>

        <div class="table-header-action">
          アクション
        </div>
      </div>

      <div
        v-for="(event, index) in eventCloseds"
        :key="index"
        class="table-cell"
        @click="editEventClosed(event)"
        >

        <div class="table-cell-event">
          {{ event.get('name') }}
        </div>

        <div class="table-cell-place">
          {{ event.get('place') }}
        </div>

        <div class="table-cell-date">
          {{ date(event) }}
        </div>

        <div class="table-cell-start">
          {{ event.get('start') }}
        </div>

        <div class="table-cell-finish">
          {{ event.get('finish') }}
        </div>

        <div class="table-cell-action">
          <div class="icons">
            <icon-quizset :event="event" />
            <icon-entry :event="event" />
            <icon-export :event="event" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { format } from 'date-fns'
import IconQuizset from '@/components/EventClosed/IconQuizset'
import IconEntry from '@/components/EventClosed/IconEntry'
import IconExport from '@/components/EventClosed/IconExport'

export default {
  components: {
    IconQuizset,
    IconEntry,
    IconExport
  },

  computed: {
    ...mapState('eventClosed', [
      'eventCloseds'
    ])
  },

  methods: {
    editEventClosed: function (event) {
      this.$router.push({
        name: 'event-closed-edit',
        params: { id: event.id }
      })
    },

    date: function (event) {
      return format(event.get('date'), 'M月D日')
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin cell {
  &-event {
    padding: 5px;
    width: 25%;
  }

  &-place {
    padding: 5px;
    width: 15%;
  }

  &-date {
    padding: 5px;
    width: 15%;
  }

  &-start {
    padding: 5px;
    width: 15%;
  }

  &-finish {
    padding: 5px;
    width: 15%;
  }

  &-action {
    padding: 5px;
    width: 15%;
  }
}

@import '@/styles/_table.scss';
</style>
